<template>
  <div class="activity">
    <search-layout>
      <div class="item">
        <label>赛事标题：</label>
        <div class="input">
          <a-input
            placeholder="请输入歌曲名称"
            size="large"
            v-model:value="params.title"
          />
        </div>
      </div>

      <div class="item">
        <label>是否上架：</label>
        <a-select size="large" v-model:value="params.status">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">上架</a-select-option>
          <a-select-option value="2">下架</a-select-option>
        </a-select>
      </div>
      <div class="item">
        <label>日期：</label>
        <a-range-picker size="large" @change="change" format="YYYY-MM-DD" />
      </div>
      <template #button>
        <a-button type="primary" size="large" @click="search">搜索</a-button>
        <a-button size="large" class="marLeft" @click="goTo('/activity/add')"
          >新增</a-button
        >
      </template>
    </search-layout>
    <table-layout>
      <a-table
        :dataSource="list"
        :columns="columns"
        rowKey="id"
        :pagination="pagination"
        :scroll="{ y: true }"
        :loading="loading"
        @change="handleTableChange"
      >
        <template #status="{record}">
          <span :class="record.status == 2 ? 'red' : ''">{{
            record.status == 2 ? "否" : "是"
          }}</span>
        </template>
        <template #createdAt="{record}">
          {{ record.createdAt }}
        </template>
        <template #action="{ record }">
          <a-button :type="record.status == 2 ? 'primary' : 'danger'" size="small" @click="updateStatus(record)">{{
            record.status == 2 ? "上架" : "下架"
          }}</a-button>
          <a-button
            class="marLeft"
            type="primary"
            size="small"
            @click="edit(record)"
            >编辑</a-button
          >
        </template>
      </a-table>
    </table-layout>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from "vue";
import { useRouter } from "vue-router";
import searchLayout from "@/layout/search";
import tableLayout from "@/layout/table";
import { message } from "ant-design-vue";
import columns from "./columns";
import { getList, update } from "@/api/match";

export default {
  setup() {
    const state = reactive({
      list: [],
      date: "",
      params: {
        limit: 10,
        offset: 0,
        title: "",
        status: "",
        startTime: "",
        endTime: "",
      },
      pagination: {
        total: 0,
      },
      loading: true,
    });
    const router = useRouter();
    const goTo = (url) => {
      router.push(url);
    };
    const init = () => {
      getList(state.params)
        .then((res) => {
          state.list = res.rows;
          state.pagination.total = res.count;
        })
        .finally(() => {
          state.loading = false;
        });
    };
  
    const updateStatus = (record) => {
      let status = record.status == 1 ? 2 : 1;
      update(record.id, { status }).then((res) => {
        record.status = status;
        message.success(status == 1 ? "上架成功" : "下架成功");
      });
    };
    const change = (value, dateString) => {
      state.params.startTime = dateString[0];
      state.params.endTime = dateString[1];
    };
    const search = () => {
      state.params.offset = 0;

      init();
    };
    const handleTableChange = ({ current }) => {
      state.params.offset = (current - 1) * state.params.limit;
      init();
    };

    const edit = (record) => {
       goTo(`/activity/update/${record.id}`);
    };
    onMounted(() => {
      init();
    });
    return {
      searchLayout,
      tableLayout,
      ...toRefs(state),
      columns,
      goTo,
      updateStatus,
      search,
      change,

      handleTableChange,
      edit,
    };
  },
};
</script>

<style lang="less">
.activity {
  height: 100%;
  overflow: hidden;
  .marLeft {
    margin-left: 10px;
  }
}
</style>
